// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1mlmu","modalFooterButton":"ModalNotes_modalFooterButton__1aPNx"};